// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aMo6","label":"styles_label__3GseE"};